import { render, staticRenderFns } from "./TfaActivation.vue?vue&type=template&id=7b8b0ca4&scoped=true"
import script from "./TfaActivation.vue?vue&type=script&lang=js"
export * from "./TfaActivation.vue?vue&type=script&lang=js"
import style0 from "./TfaActivation.vue?vue&type=style&index=0&id=7b8b0ca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b0ca4",
  null
  
)

/* custom blocks */
import block0 from "myra-ui-common/i18n/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fsoftware-engineering%2Fmyracloud-app%2Fuser-management%2Flogin%2Fsrc%2Fcomponents%2Fauthentication%2Ftfa%2FTfaActivation.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./i18n.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Fsoftware-engineering%2Fmyracloud-app%2Fuser-management%2Flogin%2Fsrc%2Fcomponents%2Fauthentication%2Ftfa%2FTfaActivation.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports